import React from 'react';
import { chipBase } from './StatusChip.style';

const StatusChip = ({ status, chipStyles }) => {
    const style = chipStyles?.[status] || chipStyles?.Identification || {};
    return (
        <span style={{ ...chipBase, color: style.color, border: `1px solid ${style.borderColor}` }}>
            {status}
        </span>
    );
};

export default StatusChip;
